export const SET_NUMBERS       = 'SET_NUMBERS';
export const ADD_NUMBERS       = 'ADD_NUMBERS';
export const REMOVE_NUMBER     = 'REMOVE_NUMBER';
export const SET_DOMAIN_NAME   = 'ADD_DOMAIN_NAME';
export const SET_FOLIO_API_KEY = 'SET_FOLIO_API_KEY';
